import React, { useState, useEffect } from "react";
import { Col, Container, Nav, Row, Tab, Card } from "react-bootstrap";
import { useParams, useLocation, useHistory } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import { useTranslation } from "react-i18next";
import Layout from "../../Layout";
import TitleCommon from "../TitleCommon";
import { StyledTabs } from "../StyledCommon";
import FormBriefcase from "../Briefcase/FormBriefcase";
// RiesgosBriefcase y NovedadesBriefcase: tabs ocultos temporalmente (2026-06-18), no se eliminó el componente.
import CompromisosBriefcase from "./CompromisosBriefcase";
import AprendizajesBriefcase from "./AprendizajesBriefcase";
import RetrospectivasBriefcase from "./RetrospectivasBriefcase";
import RetroBoard from "../RetroBoard/RetroBoard";
import { getData } from "../../helpers";
import { BriefcaseServices } from "./BriefcaseServices";

const EditBriefcase = () => {
  const [t] = useTranslation("briefcase");
  const [ddlForm, setDdlForm] = useState([]);
  const [briefcaseData, setBriefcaseData] = useState(null);
  let { uid } = useParams();
  const { search, pathname } = useLocation();
  const history = useHistory();
  const [activeKey, setActiveKey] = useState(
    new URLSearchParams(search).get("tab") || "general"
  );

  // Mantiene el tab activo en la URL (?tab=) para que sobreviva a un F5. Sin esto, al recargar
  // estando en un sub-tab (impedimentos/aprendizajes/retrospectivas/retro-tablero) se volvía al tab
  // "general". Se usa history.replace para no ensuciar el historial del navegador con cada clic.
  const handleSelectTab = (key) => {
    setActiveKey(key);
    history.replace(`${pathname}?tab=${key}`);
  };

  const getDDLProjects = async () => {
    const data = await getData("edit-project-ddls", []);
    setDdlForm(data);
  };

  const getBriefcaseDetail = async () => {
    try {
      const data = await BriefcaseServices.getById(uid);
      setBriefcaseData(data);
    } catch (error) {
      setBriefcaseData(null);
    }
  };

  useEffect(() => {
    getDDLProjects();
    if (uid) {
      getBriefcaseDetail();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uid]);

  useEffect(() => {
    ReactTooltip.rebuild();
  });

  return (
    <>
      <Layout>
        <TitleCommon
          title={{
            text: uid ? t("briefcase_title_edit") : t("briefcase_title_create"),
            icon: uid ? "pen" : "plus",
          }}
          color={uid ? "secondary" : "success"}
          goBack={{
            text: t("briefcase_title_back"),
            icon: "arrow-left",
          }}
        />
        <Container fluid>
          <Tab.Container
            activeKey={activeKey}
            onSelect={handleSelectTab}
            transition={false}
          >
            <Row className="bg-light">
              <Col>
                <StyledTabs as={Nav}>
                  <Nav.Item>
                    <Nav.Link eventKey="general">
                      {t("briefcase_title_settingBriefcase")}
                    </Nav.Link>
                  </Nav.Item>
                  {uid ? (
                    <>
                      {/* Riesgos: tab oculto temporalmente a pedido de negocio (2026-06-18). No se borra el código, solo se oculta. */}
                      <Nav.Item>
                        <Nav.Link eventKey="compromisos">
                          {t("artefactos_tab_compromisos")}
                        </Nav.Link>
                      </Nav.Item>
                      {/* Novedades: tab oculto temporalmente a pedido de negocio (2026-06-18). No se borra el código, solo se oculta. */}
                      <Nav.Item>
                        <Nav.Link eventKey="aprendizajes">
                          {t("artefactos_tab_aprendizajes")}
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="retrospectivas">
                          {t("artefactos_tab_retrospectivas")}
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="retro-tablero">
                          {t("artefactos_tab_retro_tablero")}
                        </Nav.Link>
                      </Nav.Item>
                    </>
                  ) : null}
                </StyledTabs>
              </Col>
            </Row>
            <Row>
              <Col className="pt-3 pb-5 mb-5">
                <Tab.Content>
                  <Tab.Pane
                    eventKey="general"
                    className="animate__animated animate__fadeIn"
                  >
                    <Container>
                      <FormBriefcase
                        uid={uid}
                        ddlForm={ddlForm}
                        briefcaseData={briefcaseData}
                      />
                    </Container>
                  </Tab.Pane>
                  {uid ? (
                    <>
                      {/* Riesgos: panel oculto temporalmente junto con su tab (2026-06-18). */}
                      <Tab.Pane
                        eventKey="compromisos"
                        className="animate__animated animate__fadeIn"
                      >
                        <Container fluid>
                          <Card className="shadow-sm border-0 mb-4">
                            <Card.Header className="bg-white py-3">
                              <div className="d-flex align-items-center">
                                <div>
                                  <h5 className="mb-1 fw-bold">
                                    {t("artefactos_tab_compromisos")}
                                  </h5>
                                  <p className="mb-0 text-muted small">
                                    Gestiona y monitorea los impedimentos asociados a este portafolio
                                  </p>
                                </div>
                              </div>
                            </Card.Header>
                            <Card.Body className="p-4">
                              <CompromisosBriefcase
                                idPortafolio={uid}
                                proyectos={
                                  briefcaseData ? briefcaseData.proyectos : []
                                }
                              />
                            </Card.Body>
                          </Card>
                        </Container>
                      </Tab.Pane>
                      {/* Novedades: panel oculto temporalmente junto con su tab (2026-06-18). */}
                      <Tab.Pane
                        eventKey="aprendizajes"
                        className="animate__animated animate__fadeIn"
                      >
                        <Container fluid>
                          <Card className="shadow-sm border-0 mb-4">
                            <Card.Header className="bg-white py-3">
                              <div className="d-flex align-items-center">
                                <div>
                                  <h5 className="mb-1 fw-bold">
                                    {t("artefactos_tab_aprendizajes")}
                                  </h5>
                                  <p className="mb-0 text-muted small">
                                    Gestiona los aprendizajes registrados en este portafolio
                                  </p>
                                </div>
                              </div>
                            </Card.Header>
                            <Card.Body className="p-4">
                              <AprendizajesBriefcase
                                idPortafolio={uid}
                                proyectos={
                                  briefcaseData ? briefcaseData.proyectos : []
                                }
                              />
                            </Card.Body>
                          </Card>
                        </Container>
                      </Tab.Pane>
                      <Tab.Pane
                        eventKey="retrospectivas"
                        className="animate__animated animate__fadeIn"
                      >
                        <Container fluid>
                          <Card className="shadow-sm border-0 mb-4">
                            <Card.Header className="bg-white py-3">
                              <div className="d-flex align-items-center">
                                <div>
                                  <h5 className="mb-1 fw-bold">
                                    {t("artefactos_tab_retrospectivas")}
                                  </h5>
                                  <p className="mb-0 text-muted small">
                                    Gestiona las retrospectivas registradas en este portafolio
                                  </p>
                                </div>
                              </div>
                            </Card.Header>
                            <Card.Body className="p-4">
                              <RetrospectivasBriefcase
                                idPortafolio={uid}
                                proyectos={
                                  briefcaseData ? briefcaseData.proyectos : []
                                }
                              />
                            </Card.Body>
                          </Card>
                        </Container>
                      </Tab.Pane>
                      <Tab.Pane
                        eventKey="retro-tablero"
                        className="animate__animated animate__fadeIn"
                      >
                        <Container fluid>
                          <Card className="shadow-sm border-0 mb-4">
                            <Card.Header className="bg-white py-3">
                              <div className="d-flex align-items-center">
                                <div>
                                  <h5 className="mb-1 fw-bold">
                                    {t("artefactos_tab_retro_tablero")}
                                  </h5>
                                  <p className="mb-0 text-muted small">
                                    Corre la retrospectiva del sprint: columnas, tarjetas, votos y likes
                                  </p>
                                </div>
                              </div>
                            </Card.Header>
                            <Card.Body className="p-4">
                              <RetroBoard
                                idPortafolio={uid}
                                proyectos={
                                  briefcaseData ? briefcaseData.proyectos : []
                                }
                              />
                            </Card.Body>
                          </Card>
                        </Container>
                      </Tab.Pane>
                    </>
                  ) : null}
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </Container>
      </Layout>
    </>
  );
};

export default EditBriefcase;